module.exports = __WEBPACK_EXTERNAL_MODULE_57__;


//////////////////
// WEBPACK FOOTER
// external "@ngx-translate/core"
// module id = 57
// module chunks = 0